import './AppPage.scss';
import React from 'react';
import AppPageBody from './AppPageBody';
import AppPageHeader from './AppPageHeader';
import classNames from 'classnames';
import { Helmet } from 'react-helmet';

export type AppPageProps = {
  title: string;
  meta?: { name: string; content: string };
} & React.HTMLAttributes<HTMLDivElement>;

function AppPage(props: AppPageProps) {
  return (
    <>
      <Helmet>
        <title>{props.title}</title>
        {props.meta && <meta name={props.meta.name} content={props.meta.content} />}
      </Helmet>
      <div className={classNames('app-page', { [props.className]: !!props.className })}>{props.children}</div>
    </>
  );
}

export { AppPage, AppPageHeader, AppPageBody };
